module.exports = require("mocha");


//////////////////
// WEBPACK FOOTER
// external "mocha"
// module id = 12
// module chunks = 0